// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tel-dialog .el-dialog__footer,.tel-dialog .el-dialog__header{border:0!important}.tel-dialog .el-dialog__title{font-size:16px}.tel-dialog .el-dialog__body{padding:10px 50px}.drawer-no-header{overflow:hidden}.drawer-no-header .el-drawer{overflow:visible}.drawer-no-header .el-drawer__header{display:none}", ""]);
// Exports
module.exports = exports;
